import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../NotificationDrawer.module.scss';
export const NoNotification = ({ NO_NOTIFICATIONS, className = '' }) => {
    return (_jsx("span", { "data-testid": "no-notification", className: `${styles['no-notification']} d-flex u-fs--16 py-2 ${className}`, children: NO_NOTIFICATIONS }));
};
